
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconOctagonAlertSelector = "fhi-icon-octagon-alert";

/**
 * ## FhiIconOctagonAlert
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-octagon-alert
 * @element fhi-icon-octagon-alert
 */
@customElement(FhiIconOctagonAlertSelector)
export class FhiIconOctagonAlert extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M15.584 1.264a2.75 2.75 0 0 1 1.673.792h-.001l4.687 4.687h.001a2.75 2.75 0 0 1 .806 1.944v6.626a2.75 2.75 0 0 1-.806 1.944v-.001l-4.688 4.687v.001a2.75 2.75 0 0 1-1.944.806H8.689a2.75 2.75 0 0 1-1.945-.806l-4.687-4.688a2.75 2.75 0 0 1-.806-1.944V8.689l.014-.272c.062-.63.34-1.222.792-1.673l4.687-4.687a2.75 2.75 0 0 1 1.944-.806h6.626zM8.688 2.75c-.33 0-.649.132-.883.366L3.116 7.805a1.25 1.25 0 0 0-.366.883v6.624l.006.123c.028.287.155.555.36.76l4.689 4.689.091.083c.223.182.503.283.792.283h6.624c.33 0 .649-.132.883-.366l4.689-4.689.083-.091a1.25 1.25 0 0 0 .283-.792V8.688c0-.33-.132-.649-.366-.883l-4.689-4.689a1.25 1.25 0 0 0-.76-.36l-.123-.006zM12.01 15a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zM12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
